// ---------------------------------
// client/src/pages/Login.jsx
// User login page
// ---------------------------------
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { loginRequest } from '../utils/api';
import PasswordField from '../components/PasswordField';

const TEXT = {
    title: 'כניסה',
    email: 'כתובת אימייל',
    password: 'סיסמה',
    submit: 'כניסה',
    error: 'פרטי ההתחברות שגויים. נסה שוב.',
    signupHint: 'עדיין אין לך חשבון?',
    signupAction: 'הרשמה',
};

export default function Login() {
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [error, setError] = useState('');
    const [isSubmitting, setIsSubmitting] = useState(false);
    const navigate = useNavigate();

    const handleSubmit = async (event) => {
        event.preventDefault();
        setError('');
        setIsSubmitting(true);
        try {
            const data = await loginRequest({ email, password });
            if (data?.token) {
                localStorage.setItem('token', data.token);
                navigate('/', { replace: true });
                return;
            }
            setError(TEXT.error);
        } catch (err) {
            setError(err.response?.data?.message || TEXT.error);
        } finally {
            setIsSubmitting(false);
        }
    };

    return (
        <div className="page page--auth page--accent stack stack--lg">
            <header className="page__header">
                <h1 className="page__title">{TEXT.title}</h1>
            </header>
            <section className="form-card">
                <form className="stack" onSubmit={handleSubmit}>
                    <label className="form-field">
                        <span className="form-field__label">{TEXT.email}</span>
                        <input
                            className="form-field__control"
                            type="email"
                            value={email}
                            onChange={(event) => setEmail(event.target.value)}
                            required
                        />
                    </label>
                    <PasswordField
                        label={TEXT.password}
                        value={password}
                        onChange={(event) => setPassword(event.target.value)}
                        autoComplete="current-password"
                        required
                    />
                    {/* OTP challenge UI was removed with backend OTP enforcement disabled. */}
                    {error && <div className="alert alert--danger">{error}</div>}
                    <button type="submit" className="button button--primary" disabled={isSubmitting}>
                        {TEXT.submit}
                    </button>
                </form>
            </section>
            <div className="flex">
                <span>{TEXT.signupHint}</span>
                <button type="button" className="button button--ghost" onClick={() => navigate('/signup')}>
                    {TEXT.signupAction}
                </button>
            </div>
        </div>
    );
}
